module.exports = __webpack_public_path__ + "static/media/JeffAndClaire-4.e8f354b2.png";